const ITEMS = [
  "100% Organic USA Hemp",
  "Broad-Spectrum Comfort",
  "Third-Party Lab Focus",
  "Low-THC · Under 0.3%",
  "Vet-Guided Formula",
  "For Every Doodle Breed",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="cbdoodle-marquee-container" className="overflow-hidden bg-[#2D4338] py-5">
      <div className="flex w-max animate-marquee items-center gap-0 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-serif text-lg italic text-[#F3EDE2] sm:text-xl">{item}</span>
            <span className="text-[#C58F3B]">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
